/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AWSSQSConfig,
  AWSSQSConfig$inboundSchema,
  AWSSQSConfig$Outbound,
  AWSSQSConfig$outboundSchema,
} from "./awssqsconfig.js";
import {
  AWSSQSCredentials,
  AWSSQSCredentials$inboundSchema,
  AWSSQSCredentials$Outbound,
  AWSSQSCredentials$outboundSchema,
} from "./awssqscredentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationCreateAWSSQS = {
  /**
   * Optional user-provided ID. A UUID will be generated if empty.
   */
  id?: string | undefined;
  /**
   * Type of the destination. Must be 'aws_sqs'.
   */
  type: "aws_sqs";
  /**
   * "*" or an array of enabled topics.
   */
  topics: Topics;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config: AWSSQSConfig;
  credentials: AWSSQSCredentials;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationCreateAWSSQS$inboundSchema: z.ZodType<
  DestinationCreateAWSSQS,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string().optional(),
  type: z.literal("aws_sqs"),
  topics: Topics$inboundSchema,
  filter: z.nullable(z.record(z.any())).optional(),
  config: AWSSQSConfig$inboundSchema,
  credentials: AWSSQSCredentials$inboundSchema,
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationCreateAWSSQS$Outbound = {
  id?: string | undefined;
  type: "aws_sqs";
  topics: Topics$Outbound;
  filter?: { [k: string]: any } | null | undefined;
  config: AWSSQSConfig$Outbound;
  credentials: AWSSQSCredentials$Outbound;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationCreateAWSSQS$outboundSchema: z.ZodType<
  DestinationCreateAWSSQS$Outbound,
  z.ZodTypeDef,
  DestinationCreateAWSSQS
> = z.object({
  id: z.string().optional(),
  type: z.literal("aws_sqs"),
  topics: Topics$outboundSchema,
  filter: z.nullable(z.record(z.any())).optional(),
  config: AWSSQSConfig$outboundSchema,
  credentials: AWSSQSCredentials$outboundSchema,
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationCreateAWSSQSToJSON(
  destinationCreateAWSSQS: DestinationCreateAWSSQS,
): string {
  return JSON.stringify(
    DestinationCreateAWSSQS$outboundSchema.parse(destinationCreateAWSSQS),
  );
}
export function destinationCreateAWSSQSFromJSON(
  jsonString: string,
): SafeParseResult<DestinationCreateAWSSQS, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationCreateAWSSQS$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationCreateAWSSQS' from JSON`,
  );
}
